import { render, staticRenderFns } from "./MicroarrayRetired.vue?vue&type=template&id=257092ea&scoped=true"
import script from "./MicroarrayRetired.vue?vue&type=script&lang=js"
export * from "./MicroarrayRetired.vue?vue&type=script&lang=js"
import style0 from "./MicroarrayRetired.vue?vue&type=style&index=0&id=257092ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257092ea",
  null
  
)

export default component.exports